import React, { useEffect, useState } from 'react'
import useGetDisponibilidadAgendamientos from '../../../../queries/solicitudes/useGetDisponibilidadAgendamientos';
import "./agendarStyle.scss";
import { Alert } from '@mui/material';

const Agendar = ({ idContrato, setParametrosConfirmacion, parametrosConfirmacion, infoError = null }) => {

    const queryDisponibilidadAgendamientos = useGetDisponibilidadAgendamientos();
    const [fechasRespuestaApi, setFechasRespuestaApi] = useState([]);
    const [fechasDisponibilidad, setFechasDisponibilidad] = useState(null);
    const [selectedFechaIndex, setSelectedFechaIndex] = useState(null);
    const [seleccionFechaOn, setSeleccionFechaOn] = useState(false);

    useEffect(() => {
        queryDisponibilidadAgendamientos.mutate({ idContrato: idContrato });
    }, [])

    useEffect(() => {
        if (queryDisponibilidadAgendamientos.isSuccess) {
            let respuestaApi = queryDisponibilidadAgendamientos.data.success.descripcionRespuesta ?? [];



            const formattedFecha = respuestaApi.map((fechasDispo) => {
                const originalDate = fechasDispo.fecha;
                const parts = originalDate.split("-");
                const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                return { ...fechasDispo, fecha: formattedDate };
            });

            setFechasRespuestaApi(formattedFecha);
        }
    }, [queryDisponibilidadAgendamientos.isSuccess]);

    useEffect(() => {
        const fechasConEstadoTrue = fechasRespuestaApi.filter(
            (objeto) => objeto.estado === true
        );

        setFechasDisponibilidad(fechasConEstadoTrue);
    }, [fechasRespuestaApi]);

    const handleSeleccionFecha = (fechaSeleccionada, index) => {
        let horaInicioSeleccionada = fechaSeleccionada.Inicio;
        let horaFinSeleccionada = fechaSeleccionada.Fin;
        let horaInicioFormateada = horaInicioSeleccionada
            .split(":")
            .slice(0, 2)
            .join(":");
        let horaFinFormateada = horaFinSeleccionada
            .split(":")
            .slice(0, 2)
            .join(":");
        let horaSeleccionada = `${horaInicioFormateada}-${horaFinFormateada}`;
        let separarFechaSeleccionada = fechaSeleccionada.fecha.split("-");
        let formateoFechaSeleccionada =
            separarFechaSeleccionada[2] +
            "-" +
            separarFechaSeleccionada[1] +
            "-" +
            separarFechaSeleccionada[0];

        setSelectedFechaIndex(index);
        // Eliminar 'carga' de parametrosConfirmacion antes de setear
        const { carga, ...resto } = parametrosConfirmacion;
        setParametrosConfirmacion({
            ...resto,
            hora_id: fechaSeleccionada.hora_id,
            agen_fecha: formateoFechaSeleccionada,
            agen_hora: horaSeleccionada,
            agen_fecha_mostrar: fechaSeleccionada.fecha,
        });
        setSeleccionFechaOn(true);
    };

    return (
        <div>{fechasDisponibilidad ? (
            <div className="box">
                {fechasDisponibilidad.length == 0 && <Alert severity="warning" sx={{ fontFamily: "Montserrat" }}>
                    No hay Agendamientos disponibles
                </Alert>}
                <div className="box__content">
                    <div className="form-row">

                        <div className="item__container top-row">
                            {fechasDisponibilidad.slice(0, 4).map((fechaItem, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleSeleccionFecha(fechaItem, index)}
                                    className={
                                        selectedFechaIndex === index ? "item__selected" : "item"
                                    }
                                >
                                    <h3>{fechaItem.fecha}</h3>
                                    {fechaItem.jornada}
                                </div>
                            ))}
                        </div>
                        <div className="item__container bottom-row">
                            {fechasDisponibilidad.slice(4, 8).map((fechaItem, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleSeleccionFecha(fechaItem, index + 4)}
                                    className={
                                        selectedFechaIndex === index + 4 ? "item__selected" : "item"
                                    }
                                >
                                    <h3>{fechaItem.fecha}</h3>
                                    {fechaItem.jornada}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            "Cargando..."
        )}</div>
    )
}

export default Agendar